import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const HeroPortfolio = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      } transition-all duration-500`}
    >
      <section
        className={`relative mx-auto flex justify-center items-center py-32 sm:py-40 px-4 sm:px-10 md:px-20 transition-all duration-500`}
      >
        <div className="w-full max-w-[1536px]">
          <h1
            className={`${
              theme === "dark" ? "text-black" : "text-white"
            } bricolage-grotesque-bold text-center transition-all duration-500
            text-[78px] sm:text-[80px] md:text-[120px] lg:text-[160px]
            mt-16 sm:mt-14 leading-[1.1] break-words`}
          >
            Our Work
             <span className="text-[#9803FA]"> !</span>
          </h1>
        </div>
      </section>
    </div>
  );
};

export default HeroPortfolio;
